import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  TabContent,
  TabPane,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
} from "reactstrap";
import classnames from "classnames";
import SavedRows from "../../../components/SavedRows";
import ApiService from "../../../config/restapi";
import Select from "react-select";
import { withRouter } from "react-router-dom";
import DateRangePicker from "../../../components/DateRangePicker";
import Common from "../../../helpers/common";

// const DegreeDropDownData = [
//     {
//         "value": 1,
//         "label": "B.Tech/B.E.",
//         "courses": [
//             { label: "Civil Engineering", value: 12 },
//             { label: "Electrical Engineering", value: 12 },
//             { label: "Mechanical Engineering", value: 12 },
//             { label: "Computer Science Engineering", value: 12 },
//             { label: "Artificial Intelligence", value: 12 },
//             { label: "Electronics and Communications Engineering", value: 12 },
//             { label: "Chemical Engineering", value: 12 },
//             { label: "Marine Engineering", value: 12 },
//             { label: "Metallurgical Engineering", value: 12 },
//             { label: "Petroleum Engineering", value: 12 },

const DegreeDropDownData = [
  {
    value: 1,
    label: "B.Tech/B.E.",
    courses: [
      { label: "Civil Engineering", value: 12 },
      { label: "Electrical Engineering", value: 12 },
      { label: "Mechanical Engineering", value: 12 },
      { label: "Computer Science Engineering", value: 12 },
      { label: "Artificial Intelligence", value: 12 },
      { label: "Electronics and Communications Engineering", value: 12 },
      { label: "Chemical Engineering", value: 12 },
      { label: "Marine Engineering", value: 12 },
      { label: "Metallurgical Engineering", value: 12 },
      { label: "Petroleum Engineering", value: 12 },
      { label: "Oher", value: 12 },
    ],
  },
  {
    value: 2,
    label: "B.A",
    courses: [
      { label: "BA English", value: 12 },
      { label: "BA English Literature", value: 12 },
      { label: "BA Psychology", value: 12 },
      { label: "BA History", value: 12 },
      { label: "BA Economics", value: 12 },
      { label: "BA Sociology", value: 12 },
      { label: "BA Political Science", value: 12 },
      { label: "BA Journalism and Mass Communication", value: 12 },
      { label: "BA LLB", value: 12 },
      { label: "Other", value: 12 },
    ],
  },
  {
    value: 3,
    label: "BSc",
    courses: [
      { label: "BSc Agriculture", value: 12 },
      { label: "BSc Biotechnology", value: 12 },
      { label: "BSc Zoology", value: 12 },
      { label: "BSc Clinical Research & Healthcare Management", value: 12 },
      { label: "BSc Microbiology", value: 12 },
      { label: "BSc Nursing", value: 12 },
      { label: "B.Sc.Physiotherapy", value: 12 },
      { label: "B.Sc.Radiology", value: 12 },
      { label: "B.Sc.Physics", value: 12 },
      { label: "B.Sc.Chemistry", value: 12 },
      { label: "B.Sc.Botany", value: 12 },
      { label: "B.Sc.IT", value: 12 },
      { label: "B.Sc.Computer Science", value: 12 },
      { label: "Oher", value: 12 },
    ],
  },
  {
    value: 4,
    label: "B.Com",
    courses: [
      { label: "B.Com(Economics)", value: 12 },
      { label: "B.Com(Accounting & Finance)", value: 12 },
      { label: "B.Com(Financial Markets)", value: 12 },
      { label: "B.Com(Banking & Insurance)", value: 12 },
      { label: "B.Com(Taxation)", value: 12 },
      { label: "B.com Banking and Insurance", value: 12 },
      { label: "Corporate Accountancy", value: 12 },
      { label: "Advertising and Brand Management", value: 12 },
      { label: "Principles and Practice of Accountancy", value: 12 },
      { label: "Oher", value: 12 },
    ],
  },
];

const CollegeDropDownData = [
  {
    value: 1,
    label: "College1",
  },
  {
    value: 2,
    label: "College2",
  },
  {
    value: 3,
    label: "College3",
  },
];

const EducationalDetails = (props) => {
  const [editIndex, setEditIndex] = useState(-1);
  const [educationalRows, setEducationalRows] = useState([
    {
      college: "",
      degree: "",
      course: "",
      start_year: "",
      grad_year: "",
      stillStudying: false,
    },
  ]);
  const [coursesList, setCoursesList] = useState([]);
  const [showError, setShowError] = useState(false);

  const [invalidFormat, setInvalidFormat] = useState("");
  useEffect(() => {
    props.onNextClickEduDataCallBack(educationalRows, editIndex);
  }, [educationalRows, editIndex]);

  function checkInvalidity(item) {
    let Valid;
    if (item.college) {
      var RegEx = /^(?![0-9]+$)[a-zA-Z0-9 ]{2,}$/;
      Valid = RegEx.test(item.college);
      if (!Valid) {
        setInvalidFormat("Numbers are not allowed");
      }
      console.log(Valid);
    }
    return (
      !Valid ||
      !item.college ||
      !item.degreeObj ||
      !item.start_year ||
      (!item.stillStudying &&
        (!item.grad_year || item.grad_year < item.start_year))
    );
  }

  function handleAddEducationalRow() {
    if (checkInvalidity(educationalRows[0])) {
      setShowError(true);
      return;
    }
    ApiService.saveEducationDetailsOnBoarding(educationalRows).then((res) => {
      if (res && res.status === 200 && res.data) {
        props.updateEducationData();
        const item1 = {
          degreeObj: "",
          courseObj: "",
          collegeObj: "",
          college: "",
          degree: "",
          course: "",
          start_year: "",
          grad_year: "",
          stillStudying: false,
        };
        let updateERow = [...educationalRows];
        updateERow.splice(updateERow.length - 1, 1);
        let addIdx = updateERow.length > 0 ? updateERow.length - 1 : 0;
        updateERow.splice(addIdx, 0, item1);
        if (editIndex > -1) setEditIndex(-1);
        setEducationalRows(updateERow);
        setShowError(false);
      }
    });
  }

  function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }

  const editEducationalRow = (data, index) => {
    if (index > -1) {
      const tempRowData = [...props.getSavedRows];
      const tempEduData = [...educationalRows];
      let degreeIndex = findWithAttr(
        DegreeDropDownData,
        "label",
        tempRowData[index].degree
      );
      tempRowData[index].degreeObj = DegreeDropDownData[degreeIndex];
      let collegeIndex = findWithAttr(
        CollegeDropDownData,
        "label",
        tempRowData[index].college
      );
      tempRowData[index].collegeObj = CollegeDropDownData[collegeIndex];
      if (degreeIndex > -1) {
        const courseIndex = findWithAttr(
          DegreeDropDownData[degreeIndex].courses,
          "label",
          tempRowData[index].course
        );
        if (courseIndex > -1)
          tempRowData[index].courseObj =
            DegreeDropDownData[degreeIndex].courses[courseIndex];
        setCoursesList(DegreeDropDownData[degreeIndex].courses);
      }
      Object.assign(tempEduData[0], tempRowData[index]);
      setEducationalRows(tempEduData);
      setEditIndex(index);
    }
  };

  function deleteEducationalRow(type, index) {
    const tempERow = [...props.getSavedRows];
    ApiService.deleteEducationDetailsOnBoarding({
      id: Number(tempERow[index].id),
    }).then((res) => {
      if (res && res.status === 200) {
        props.updateEducationData();
      }
    });
  }

  const handleSaveEditedData = () => {
    const tempRowData = [...props.getSavedRows];
    const tempEduData = [...educationalRows];
    let obj = {
      ...tempEduData[0],
      id: tempRowData[editIndex].id,
    };

    if (checkInvalidity(obj)) {
      setShowError(true);
      return;
    }

    ApiService.editEducationDetailsOnBoarding(obj).then((res) => {
      if (res && res.status === 200 && res.data) {
        props.updateEducationData();
        setEditIndex(-1);
        tempEduData[0].college = "";
        tempEduData[0].degree = "";
        tempEduData[0].course = "";
        tempEduData[0].start_year = "";
        tempEduData[0].grad_year = "";
        tempEduData[0].stillStudying = false;
        tempEduData[0].collegeObj = "";
        tempEduData[0].degreeObj = "";
        tempEduData[0].courseObj = "";
        tempEduData[0].UserId = "";
        tempEduData[0].id = "";
        setEducationalRows(tempEduData);
        setShowError(false);
      }
    });
  };

  const handleChange = (selectedOption, index) => {
    let tempRow = [...educationalRows];
    tempRow[index].degree = selectedOption.label;
    tempRow[index]["degreeObj"] = selectedOption;
    tempRow[index]["courseObj"] = "";
    setCoursesList(selectedOption.courses);
    setEducationalRows(tempRow);
  };

  const handleCollegeChange = (selectedOption, index) => {
    let tempRow = [...educationalRows];
    tempRow[index].college = selectedOption.label;
    tempRow[index]["collegeObj"] = selectedOption;
    setEducationalRows(tempRow);
  };

  const handleChangeCourse = (selectedOption, index) => {
    let tempRow = [...educationalRows];
    tempRow[index].course = selectedOption.label;
    tempRow[index]["courseObj"] = selectedOption;
    setEducationalRows(tempRow);
  };

  const onChangeEducationalDetails = (index, value, type) => {
    let tempRow = [...educationalRows];
    switch (type) {
      case "college":
        value = Common.trimStart(value.replace(/[^a-zA-Z\s]/gi, ""));
        tempRow[index].college = value;
        setInvalidFormat("");
        break;
      case "start_year":
        tempRow[index].start_year = value;
        break;
      case "grad_year":
        tempRow[index].grad_year = value;
        break;
      case "stillstudying":
        tempRow[index].stillStudying = value;
        if (value === true) {
          tempRow[index]["grad_yearDisabled"] = true;
          tempRow[index].grad_year = "";
        } else {
          tempRow[index]["grad_yearDisabled"] = false;
        }
        break;
      default:
        break;
    }
    setEducationalRows(tempRow);
  };

  function CheckAndPrint(date) {
    if (date) {
      if (typeof date === "object") {
        return date;
      } else {
        return new Date(date);
      }
    }
  }

  return (
    <TabContent
      activeTab={props.activeTab}
      className="twitter-bs-wizard-tab-content pt-0"
    >
      <TabPane tabId={2} className="educational-details text-left">
        {props.getSavedRows.length > 0 &&
          props.getSavedRows.map((data, index) => {
            return (
              <SavedRows
                data={data}
                index={index}
                editRow={editEducationalRow}
                deleteRow={deleteEducationalRow}
                type="educational"
                key={index}
              />
            );
          })}
        {educationalRows.map((item1, idx) => {
          return (
            <Form key={idx} className={classnames("pb-3")}>
              <Row>
                <Col lg="12">
                  <FormGroup>
                    {props.location && props.location.state === "student" ? (
                      <Label>
                        School/College{" "}
                        <span className="label-required"> * </span>{" "}
                      </Label>
                    ) : (
                      <Label>School/College</Label>
                    )}
                    {props.location && props.location.state === "student" ? (
                      <Select
                        className="select-container"
                        value={item1.collegeObj}
                        onChange={(selectedOption) =>
                          handleCollegeChange(selectedOption, idx)
                        }
                        options={CollegeDropDownData}
                        isSearchable
                        innerProps={{ className: "test" }}
                        placeholder="Select"
                      />
                    ) : (
                      <Input
                        maxLength="40"
                        type="text"
                        value={item1.college}
                        onChange={(event) =>
                          onChangeEducationalDetails(
                            idx,
                            event.target.value,
                            "college"
                          )
                        }
                      />
                    )}
                    {showError && !item1.college && (
                      <label style={{ "margin-bottom": "0", color: "red" }}>
                        College name cannot be blank.
                      </label>
                    )}
                    {invalidFormat && (
                      <label style={{ "margin-bottom": "0", color: "red" }}>
                        {invalidFormat ? invalidFormat : ""}
                      </label>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <FormGroup>
                    <Label>Degree</Label>
                    <Select
                      className="select-container"
                      value={item1.degreeObj}
                      onChange={(selectedOption) =>
                        handleChange(selectedOption, idx)
                      }
                      options={DegreeDropDownData}
                      isSearchable
                      innerProps={{ className: "test" }}
                      placeholder="Select"
                    />
                    {showError && !item1.degreeObj && (
                      <label style={{ "margin-bottom": "0", color: "red" }}>
                        Choose a degree from the list.
                      </label>
                    )}
                  </FormGroup>
                </Col>
                <Col lg="6">
                  <FormGroup>
                    <Label>Course</Label>
                    <Select
                      className="select-container"
                      value={item1.courseObj}
                      onChange={(selectedOption) =>
                        handleChangeCourse(selectedOption, idx)
                      }
                      options={coursesList}
                      isSearchable
                      innerProps={{ className: "test" }}
                      placeholder="Select"
                    />
                    {showError && !item1.degreeObj && (
                      <label style={{ "margin-bottom": "0", color: "red" }}>
                        Choose a degree from the list.
                      </label>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <FormGroup className="mb-0 text-left">
                    <Label>Start Year</Label>
                    <InputGroup>
                      <DateRangePicker
                        proptype="start"
                        propsref="startcalendar"
                        propsid="startyear"
                        selected={CheckAndPrint(item1.start_year)}
                        onChange={(date) =>
                          onChangeEducationalDetails(idx, date, "start_year")
                        }
                        startDate={item1.start_year}
                        endDate={new Date().getFullYear()}
                        maxDate={item1.grad_year!==""?item1.grad_year:new Date()}
                      />
                      <label htmlFor="startyear">
                        <i className="mdi mdi-calendar-blank-outline cust-date-icon"></i>
                      </label>
                    </InputGroup>
                    {showError && !item1.start_year && (
                      <label style={{ "margin-bottom": "0", color: "red" }}>
                        Start year cannot be blank.
                      </label>
                    )}
                  </FormGroup>
                </Col>
                <Col lg="6">
                  <FormGroup className="mb-0 text-left">
                    <Label>End Year</Label>
                    <InputGroup>
                      <DateRangePicker
                        proptype="end"
                        propsref="endcalendar"
                        propsid="endyear"
                        selected={CheckAndPrint(item1.grad_year)}
                        onChange={(date) =>
                          onChangeEducationalDetails(idx, date, "grad_year")
                        }
                        selectsEnd
                        startDate={item1.start_year}
                        endDate={item1.grad_year}
                        minDate={item1.start_year}
                        maxDate={new Date()}
                        readOnly={item1.grad_yearDisabled}
                      />
                      <label htmlFor="endyear">
                        {" "}
                        <i className="mdi mdi-calendar-blank-outline cust-date-icon"></i>
                      </label>
                    </InputGroup>
                    {showError &&
                      !item1.grad_year &&
                      !item1.grad_yearDisabled && (
                        <label style={{ "margin-bottom": "0", color: "red" }}>
                          End year cannot be blank.
                        </label>
                      )}
                    {showError &&
                      item1.grad_year &&
                      item1.start_year &&
                      item1.grad_year < item1.start_year && (
                        <label style={{ "margin-bottom": "0", color: "red" }}>
                          End year cannot be smller than Start year.
                        </label>
                      )}

                    <FormGroup className="pt-2" check>
                      <Label className="main" check>
                        <Input
                          type="checkbox"
                          check={
                            item1.stillStudying
                              ? item1.stillStudying.toString()
                              : false.toString()
                          }
                          onChange={(event) =>
                            onChangeEducationalDetails(
                              idx,
                              event.target.checked,
                              "stillstudying"
                            )
                          }
                        />{" "}
                        I'm still studying
                        <span className="geekmark"></span>
                      </Label>
                    </FormGroup>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          );
        })}
        <div className="cursor-pointer add-other text-right">
          {editIndex > -1 && (
            <button
              className="waves-effect waves-light btn btn-outline-shadow w-md mr-2"
              type="button"
              onClick={() => handleSaveEditedData()}
            >
              Save
            </button>
          )}
          <button
            className="waves-effect waves-light btn btn-outline-shadow w-md"
            type="button"
            disabled={
              editIndex > -1
                ? true
                : props.location && props.location.state === "student"
                ? educationalRows.length > 0 && educationalRows[0].college
                  ? false
                  : true
                : false
            }
            onClick={() => handleAddEducationalRow()}
          >
            + Add Other Educational Details
          </button>
        </div>
      </TabPane>
    </TabContent>
  );
};

export default withRouter(EducationalDetails);
